import React, {Component} from 'react';
import CampanhaService from '../../services/CampanhaService';
import TrofeuService from '../../services/TrofeuService';
import LogosCampanha from '../../comps/LogosCampanha/LogosCampanha';
import './Trofeus.css';
import TemaService from '../../services/TemaService';



class TrofeuCampanha extends Component {
    render() {
        if (this.props.url === null) {
            return (
                <div className="trofeu__sala trofeu__sala__campanha">
                </div>    
            );
        }
        return (
            <div className="trofeu__sala trofeu__sala__campanha">
                <img src={this.props.url}/>
            </div>
        )
    }
}

class Trofeu extends Component {
    render() {
        if (this.props.url === null) {
            return (
                <div>
                </div>    
            );
        }
        return (
            <div className={`trofeu__sala__dia ${this.props.maior ? "trofeu__sala__maior" : ""}`}>
                <img src={this.props.url}/>
            </div>
        )
    }
}

class Estante extends Component {

    act = {
        activities: []
    }

    constructor(props){
        super(props)
        let acts = []
        this.props.dia.activities.forEach(element => {
            let act = this.buscarTrofeu(element.type, element.activityId)
            if(act){
                acts.push(act)
            }
        })
        this.act.activities = acts;
    }
    
    trofeuTipo = (tipo) => {
        let atividade = null
        atividade = this.buscarTrofeu(tipo)
        
        if (atividade) {
            return (<Trofeu url={atividade.prize}/>)
        } else {
            return null
        }
        return null
    }

    buscarTrofeu(tipo, activityId){
        let atividade = null;
        for (var i = 0; i < this.props.dia.activities.length; i++) {
            if (this.props.dia.activities[i].type === tipo && this.props.dia.activities[i].activityId === activityId) {
                atividade = this.props.dia.activities[i]
                break;
            }
        }
        return atividade
    }

    trofeusChunks = (activities, chunks) =>{
        let final = [];
        let n = activities.length;
        for( let i = 0; i < n; i += chunks) {
          final = [...final, activities.slice(i, i + chunks)];
        }
        return final;
      }
    
    render() {
        const dia = this.props.dia

        let trofeusResults = this.trofeusChunks(this.act.activities, 5);
        let finalTrofeus = trofeusResults.map((items, key, index) => {
			return(
				<div
				key={key}
                style={{display: 'flex'}}
				>
					{
						items.map(function (el, index) {
							return (
								<Trofeu key={index} url={el.prize}/>
							);
						})
					}
				</div>
			)
		})

        return (
            <div>
            <div className="estante">
                
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'baseline'}}>
                    {finalTrofeus}
                </div>
                {/* <span style={{minWidth:'2em'}}>&nbsp;&nbsp;&nbsp;&nbsp;</span> */}
                <Trofeu url={dia.prize} maior={true}/>
            </div>
                <div className="prateleira">&nbsp;</div>
            </div>
        );
        
    }
}

export default class Trofeus extends Component {

    state = {
        trofeus:null,
        erro:null,
        campanha:null
    }

    componentDidMount() {
        new TrofeuService().obterTrofeus((erro, dados) => {
            if (erro) {
               this.setState({erro:"Erro ao obter sala de troféus, tente novamente mais tarde"})
               return
            }
            let campanhaService = new CampanhaService()
            // this.setState({trofeus:dados, campanha:campanhaService.campanhaCorrente(), cssVidro: {maxHeight: '100%'}})
            this.setState({trofeus:dados, campanha:campanhaService.campanhaCorrente(), cssVidro: {height: (105 + (83) * dados.schedule.length) + "px"}})
            let temaService = new TemaService(campanhaService.campanhaCorrente())
            temaService.aplicarTema('TROFEUS')
        })
    }

    render() {
        if (this.state.erro) {
            return (<div>{this.state.erro}</div>)
        }
        if (! this.state.trofeus) {
            return (<div style={{display:'flex', alignItems:'center', justifyContent:'center', minHeight:'100vh' }}><div>Aguarde...</div></div>)
        }
        const campanha = this.state.campanha;
        const trofeus = this.state.trofeus
        return (
            <div>
                <LogosCampanha campanha={campanha}/>
                <img src="/vidro.svg" className="vidro-sala-trofeus" style={this.state.cssVidro}></img>
                <div className="prateleira">&nbsp;</div>
                <div className="estante estante__maior">
                    <TrofeuCampanha url={trofeus.prize} />
                </div>
                <div className="prateleira">&nbsp;</div>
                {
                    trofeus.schedule.map((est, index) => {return (<Estante key={index} dia={est}/>)})
                }
            </div>
        )
    }
    
}

